// Medicine Status Options
export const STATUS_OPTIONS = [
  { label: 'Active', value: 1 },
  { label: 'Inactive', value: 0 },
] as const;

export const STATUS_FILTER_OPTIONS = [
  { label: 'Active', value: 1 },
  { label: 'Inactive', value: 0 },
] as const;

// Prescription Requirement Options
export const PRESCRIPTION_OPTIONS = [
  { label: 'Required', value: 1 },
  { label: 'Not Required', value: 0 },
] as const;

// GST Rate Options
export const GST_RATE_OPTIONS = [
  { label: '0%', value: 0 },
  { label: '5%', value: 5 },
  { label: '12%', value: 12 },
  { label: '18%', value: 18 },
  { label: '28%', value: 28 },
] as const;

// Pack Quantity Options
export const PACK_QUANTITY_OPTIONS = Array.from({ length: 100 }, (_, i) => ({
  label: `${i + 1}`,
  value: i + 1,
}));

// Common Manufacturers (you can expand this list)
export const MANUFACTURER_OPTIONS = [
  { label: 'Sun Pharma', value: 'Sun Pharma' },
  { label: 'Cipla', value: 'Cipla' },
  { label: 'Dr. Reddy\'s', value: 'Dr. Reddy\'s' },
  { label: 'Lupin', value: 'Lupin' },
  { label: 'Aurobindo', value: 'Aurobindo' },
  { label: 'Torrent', value: 'Torrent' },
  { label: 'Zydus', value: 'Zydus' },
  { label: 'Alkem', value: 'Alkem' },
  { label: 'Glenmark', value: 'Glenmark' },
  { label: 'Abbott', value: 'Abbott' },
] as const;

// Pack Size Options
export const PACK_SIZE_OPTIONS = [
  { label: '10 Tablets', value: '10 Tablets' },
  { label: '20 Tablets', value: '20 Tablets' },
  { label: '30 Tablets', value: '30 Tablets' },
  { label: '100ml Syrup', value: '100ml Syrup' },
  { label: '200ml Syrup', value: '200ml Syrup' },
  { label: '10 Capsules', value: '10 Capsules' },
  { label: '20 Capsules', value: '20 Capsules' },
  { label: '1 Injection', value: '1 Injection' },
  { label: '5 Injections', value: '5 Injections' },
  { label: '30g Cream', value: '30g Cream' },
  { label: '50g Cream', value: '50g Cream' },
] as const;